var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !this.loading
    ? _c("div", { staticClass: "rentabilidade container-fluid" }, [
        _c("div", { staticClass: "btn-visaogeral", on: { click: _vm.cycle } }, [
          _vm._v("Visão Geral")
        ]),
        _c("div", { staticClass: "card panel" }, [
          _c("label", [_vm._v("Período")]),
          _c("div", [_vm._v(_vm._s(this.calculos.periodo))])
        ]),
        _c("div", { staticClass: "card panel" }, [
          _c("label", [_vm._v("Carteira")]),
          _c("div", [_vm._v(_vm._s(this.calculos.carteira))])
        ]),
        _c("div", { staticClass: "controls panel" }, [
          _c("label", [_vm._v("Índice")]),
          _c("div", { staticClass: "btns-ativos" }, [
            _c(
              "div",
              { staticClass: "btn-cdi" },
              [
                _c("v-switch", {
                  attrs: { checked: "", label: "CDI" },
                  on: {
                    change: function($event) {
                      return _vm.changeSwitch("CDI")
                    }
                  },
                  model: {
                    value: _vm.switchStateCDI,
                    callback: function($$v) {
                      _vm.switchStateCDI = $$v
                    },
                    expression: "switchStateCDI"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "btn-ipca" },
              [
                _c("v-switch", {
                  attrs: { checked: "", label: "IPCA" },
                  on: {
                    change: function($event) {
                      return _vm.changeSwitch("IPCA")
                    }
                  },
                  model: {
                    value: _vm.switchStateIPCA,
                    callback: function($$v) {
                      _vm.switchStateIPCA = $$v
                    },
                    expression: "switchStateIPCA"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "btn-dolar" },
              [
                _c("v-switch", {
                  attrs: { label: "DÓLAR" },
                  on: {
                    change: function($event) {
                      return _vm.changeSwitch("DOLAR")
                    }
                  },
                  model: {
                    value: _vm.switchStateDOLAR,
                    callback: function($$v) {
                      _vm.switchStateDOLAR = $$v
                    },
                    expression: "switchStateDOLAR"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "btn-ibovespa" },
              [
                _c("v-switch", {
                  attrs: { label: "IBOVESPA" },
                  on: {
                    change: function($event) {
                      return _vm.changeSwitch("IBOVESPA")
                    }
                  },
                  model: {
                    value: _vm.switchStateIBOVESPA,
                    callback: function($$v) {
                      _vm.switchStateIBOVESPA = $$v
                    },
                    expression: "switchStateIBOVESPA"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "graph panel" },
          [
            _c("label", { attrs: { id: "graph-panel-label" } }, [
              _vm._v("Rentabilidade")
            ]),
            _c("MixedLine", {
              attrs: { input: _vm.acumulado, aplicacao: _vm.aplicacao }
            })
          ],
          1
        ),
        _c("div", { staticClass: "table panel" }, [
          _c("label", { attrs: { id: "table-panel-label" } }, [
            _vm._v("Acumulada")
          ]),
          _c(
            "div",
            { key: _vm.atualizacao, staticClass: "rows" },
            _vm._l(_vm.dados, function(item) {
              return _c("div", { key: item.ano, staticClass: "row" }, [
                _c("div", { staticClass: "group ano" }, [
                  _c("div", { staticClass: "cell" }, [
                    _c("div", [_vm._v("Mês")]),
                    _c("div", [_vm._v(_vm._s(item.ano))]),
                    _c("div", [_vm._v("% " + _vm._s(_vm.indice))])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "group data" },
                  _vm._l(item.items, function(child, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "cell display" },
                      [
                        _c("div", [_vm._v(_vm._s(_vm.months[index]))]),
                        _c(
                          "div",
                          {
                            attrs: {
                              title:
                                ((child && child.taxa) || "-") +
                                " (" +
                                ((item.indice &&
                                  item.indice[index] &&
                                  item.indice[index].taxa) ||
                                  "-") +
                                ")"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (child && _vm.format(child.taxa)) || "-"
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            attrs: {
                              title:
                                (item.comparado[index] &&
                                  item.comparado[index].taxa) ||
                                "-"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (item.comparado[index] &&
                                    _vm.format(item.comparado[index].taxa)) ||
                                    "-"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "group total" }, [
                  _c("div", { staticClass: "cell" }, [
                    _c("div", [_vm._v("Anual")]),
                    _c(
                      "div",
                      {
                        attrs: {
                          title:
                            item.anual.carteira + " (" + item.anual.indice + ")"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.format(item.anual.carteira)) + " "
                        )
                      ]
                    ),
                    _c("div", { attrs: { title: item.anual.comparado } }, [
                      _vm._v(
                        " " + _vm._s(_vm.format(item.anual.comparado)) + " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "cell" }, [
                    _c("div", [_vm._v("Acum.")]),
                    _c(
                      "div",
                      {
                        attrs: {
                          title:
                            item.total.carteira + " (" + item.total.indice + ")"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.format(item.total.carteira)) + " "
                        )
                      ]
                    ),
                    _c("div", { attrs: { title: item.total.comparado } }, [
                      _vm._v(
                        " " + _vm._s(_vm.format(item.total.comparado)) + " "
                      )
                    ])
                  ])
                ])
              ])
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }